<div class="stepper-container">
  <div class="steps-wrapper">
    <ng-container *ngFor="let step of steps; let i = index; let last = last">
      <div class="step-item">
        <ng-container *ngIf="useStatusIcons; else defaultIcon">
          <svg
            class="step-node"
            [attr.aria-label]="step.label"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            [ngClass]="'state-' + getStepState(i)"
          >
            <circle class="step-node__outer" cx="16" cy="16" r="15" stroke-width="2" />
            <circle *ngIf="getStepState(i) === 'active'" class="step-node__inner" cx="16" cy="16" r="6" />
            <path
              *ngIf="getStepState(i) === 'completed'"
              class="step-node__check"
              d="M24.7074 9.29244C24.3173 8.90252 23.6871 8.90252 23.297 9.29244L12.9942 19.5905L8.70297 15.3013C8.31286 14.9114 7.68269 14.9114 7.29258 15.3013C6.90247 15.6912 6.90247 16.3211 7.29258 16.711L12.294 21.7101C12.484 21.9 12.7341 22 12.9942 22C13.2542 22 13.5043 21.9 13.7044 21.7101L24.7074 10.7122C25.0975 10.3222 25.0975 9.68237 24.7074 9.29244Z"
            />
          </svg>
        </ng-container>
        <ng-template #defaultIcon>
          <span [ngClass]="getIconClasses(i)" [attr.aria-label]="step.label"></span>
        </ng-template>
      </div>

      <div *ngIf="!last"
           class="step-line"
           [ngClass]="{ 'active-line': lineIsActive(i) }">
      </div>
    </ng-container>
  </div>

  <div class="step-label-container">
    <span *ngIf="totalSteps > 0">
      {{ labelPrefix }}{{ currentStepNumber }}/{{ totalSteps }}<ng-container *ngIf="showCurrentStepLabel"> - {{ currentStepLabel }}</ng-container>
    </span>
  </div>
</div>
